import { useUIStore } from "./uiStore";
import { useCreatorStore } from "./creatorStore";
import { useSelectionStore } from "./selectionStore";
import { useErrorStore } from "./errorStore";
import { useColorStore } from "./colorStore";
import { useCartStore } from "./cartStore";

// Export all stores
export {
  useUIStore,
  useCreatorStore,
  useSelectionStore,
  useErrorStore,
  useColorStore,
  useCartStore
};

// Export types
export type { ErrorEntry, ErrorState } from "./errorStore";

// Combined store hook for convenience
export const useStores = () => {
  const uiStore = useUIStore();
  const creatorStore = useCreatorStore();
  const selectionStore = useSelectionStore();
  const errorStore = useErrorStore();
  const colorStore = useColorStore();
  const cartStore = useCartStore();

  return {
    uiStore,
    creatorStore,
    selectionStore,
    errorStore,
    colorStore,
    cartStore
  };
};

// Store initialization function
export const initializeStores = async (): Promise<boolean> => {
  try {
    const storeInitializations = [
      useUIStore.getState().initialize(),
      useErrorStore.getState().initialize(),
      useCreatorStore.getState().initialize(),
      useSelectionStore.getState().initialize(),
      useColorStore.getState().initialize(),
      useCartStore.getState().initialize()
    ];

    // Wait for all initializations to complete
    await Promise.all(
      storeInitializations.map(async (initPromise) => {
        const result = await initPromise;
        if (!result) {
          throw new Error("Store initialization failed");
        }
      })
    );

    return true;
  } catch (error) {
    console.error("Failed to initialize stores:", error);
    return false;
  }
};

// Store reset function
export const resetStores = (): void => {
  useUIStore.getState().reset();
  useCreatorStore.getState().reset();
  useSelectionStore.getState().reset();
  useErrorStore.getState().reset();
  useColorStore.getState().reset();
  useCartStore.getState().reset();
};
